require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-graphql-scalar.json") })
        }
      }, "path---package-bs-graphql-scalar");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-graphql-scalar!./.cache/json/package-bs-graphql-scalar.json
// module id = 789
// module chunks = 231608221292675